import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Cybersecurity",
          "Systems Administration",
          "Enterprise Networking",
          "Security Monitoring",
          "Active Directory",
          "Odoo Administration",
          "Automation & Scripting"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 40,
        delay: 60,
        pauseFor: 1700
      }}
    />
  );
}

export default Type;